import { useSceneState, useSceneActions } from '../../presentation/providers/SceneProvider';
import type { TransitionMode } from '../../domain/value-objects/TransitionConfig';

export function useTransitionConfig() {
  const { transitionMode } = useSceneState();
  const { setTransitionMode } = useSceneActions();

  return {
    mode: transitionMode,
    setMode: setTransitionMode,
    durationMs: transitionMode === 'crossfade' ? 150 : 0,
  };
}
